import DivisionAccessService from "@/services/DivisionAccessService";

const STORAGE_KEY = "division_selection";

let inFlightPromise = null;

const readSelection = () => {
  try {
    const ids = JSON.parse(localStorage.getItem(STORAGE_KEY));
    return Array.isArray(ids) ? ids.map(Number) : [];
  } catch (e) {
    return [];
  }
};

export default {
  namespaced: true,

  state: () => ({
    // Ids picked in the header dropdown. [] means "All" (no X-Division header).
    selected: readSelection(),
    // Bumped on every selection change so the layout can remount the page.
    version: 0,
  }),

  mutations: {
    SET_SELECTED(state, ids) {
      state.selected = ids;
      state.version++;
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
      } catch (e) {
        // storage blocked: selection just won't survive a reload
      }
    },
  },

  actions: {
    setSelected({ commit }, ids) {
      commit("SET_SELECTED", (ids || []).map(Number));
    },

    // Replaces the stored assigned list with the server's and drops stale picks.
    async refresh({ commit, state, rootState, dispatch }) {
      if (inFlightPromise) return inFlightPromise;

      inFlightPromise = DivisionAccessService.myDivisions()
        .then(async (divisions) => {
          const user = rootState.auth.user;
          if (!user) return;
          await dispatch(
            "auth/saveUserData",
            { ...user, assigned_divisions: divisions },
            { root: true },
          );
          const valid = divisions.map((d) => d.id);
          const kept = state.selected.filter((id) => valid.includes(id));
          if (kept.length !== state.selected.length) commit("SET_SELECTED", kept);
        })
        .finally(() => {
          inFlightPromise = null;
        });

      return inFlightPromise;
    },
  },

  getters: {
    assigned: (state, getters, rootState) =>
      rootState.auth.user?.assigned_divisions || [],

    // Ids for the X-Division header: the pick, else every assigned division.
    // shortcut: "All" sends the header only when something is picked; the backend
    // treats a missing header as all assigned, so omitting it is equivalent.
    headerIds: (state, getters) =>
      state.selected.filter((id) => getters.assigned.some((d) => d.id === id)),
  },
};
